import { Backdrop } from 'src/components';
import { motion } from 'framer-motion';
import IconLogoPNG from 'src/assets/loader.png';

export function Loader({ fullscreen }) {
    return (
        <Backdrop
        open={true}
        sx={{
            backgroundColor: '#fff',
            position: fullscreen ? 'fixed' : 'absolute',
            top: 0,
            left: 0,
            width: fullscreen ? '100vw' : '100%',
            height: fullscreen ? '100vh' : '100%',
            zIndex: 10000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}
        >
        <motion.img
            src={IconLogoPNG}
            alt="Loading..."
            style={{ width: 70, height: 70 }}
            animate={{
                scale: [1, 1.2, 1],       // pulse from normal → bigger → normal
            }}
            transition={{
                duration: 1,              // total time for one pulse
                repeat: Infinity,        
                ease: "easeInOut",        
            }}
        />
        </Backdrop>
    );
}
